import React from 'react';
import { FormControl, InputLabel, Select, MenuItem, CircularProgress } from '@mui/material';
import { useAppDispatch, useAppSelector } from '../../../../../../app/hooks';
import { updateSchedule } from '../../../../state';
import { useGetRecurrenceTypesQuery } from '../../../../../../services/DimensionService/dimensionApi';

const RecurrenceTypeEdit: React.FC = () => {
  const dispatch = useAppDispatch();
  const { currentRecurringTask } = useAppSelector(state => state.recurringTask);
  const { data: recurrenceTypes, isLoading, error } = useGetRecurrenceTypesQuery();

  const handleChange = (event: any) => {
    dispatch(updateSchedule({ type: event.target.value }));
  };

  return (
    <FormControl size="small" sx={{ minWidth: 150 }} required>
      <InputLabel>Recurrence Type *</InputLabel>
      <Select
        value={currentRecurringTask?.schedule?.type || 'DAILY'}
        onChange={handleChange}
        label="Recurrence Type *"
        disabled={isLoading || !!error}
      >
        {isLoading ? (
          <MenuItem disabled>
            <CircularProgress size={20} sx={{ mr: 1 }} />
            Loading...
          </MenuItem>
        ) : error ? (
          <MenuItem disabled>Error loading recurrence types</MenuItem>
        ) : (
          recurrenceTypes?.map((type) => (
            <MenuItem key={type.value} value={type.value}>
              {type.name}
            </MenuItem>
          ))
        )}
      </Select>
    </FormControl>
  );
};

export default RecurrenceTypeEdit;
